import { useTranslation } from "react-i18next";
import { Icon, Button } from "@atoms";
import { Badge } from "@shadcn";
import { Card } from "@molecules";
import { perksData } from "@pages/dashboard/perks/perks-data";
import { PlusIcon, Check, X } from "lucide-react";
import insuranceLogo from "../../../../assets/sample_insurance_logo.jpg";
import parachuteLogo from "../../../../assets/parachute-logo-small.png";
export type PerksSectionTemplateProps = {
  navigateToPage: (index: number, to: string) => void;
  addPlusIcon: boolean;
  currentLifestyleGroupName?: string;
  currentLifestyleGroupResetDate?: string;
};

export const PerksSectionTemplate = ({
  navigateToPage,
  addPlusIcon,
  currentLifestyleGroupName,
  currentLifestyleGroupResetDate,
}: PerksSectionTemplateProps): JSX.Element => {
  const { t } = useTranslation();
  const formattedResetDate = (() => {
    if (!currentLifestyleGroupResetDate) {
      return undefined;
    }
    const date = new Date(currentLifestyleGroupResetDate);
    if (Number.isNaN(date.getTime())) {
      return undefined;
    }
    return date.toLocaleDateString();
  })();

  const isProtected = false;
  const cardImageSrc = isProtected ? insuranceLogo : parachuteLogo;
  const cardTitle = isProtected
    ? currentLifestyleGroupName ?? t("perksSection.groupInsurance.title")
    : t("perksSection.groupInsurance.subtitle");
  const cardImageAlt = t("perksSection.groupInsurance.alt");
  const titleClassName = isProtected ? "font-bold" : "font-medium";
  const statusConfig = isProtected
    ? {
        label: t("perksSection.groupInsurance.statusProtected"),
        badgeClass: "bg-white border-successful-medium text-successful-medium",
        iconWrapperClass: "bg-successful-medium text-white h-5 w-5",
        iconSizeClass: "h-4 w-4",
        widthClass: "w-[150px] min-w-[150px] justify-center",
        Icon: Check,
      }
    : {
        label: t("perksSection.groupInsurance.statusNotProtected"),
        badgeClass: "bg-white border-secondary-medium text-secondary-medium",
        iconWrapperClass: "bg-secondary-medium text-white h-5 w-5",
        iconSizeClass: "h-4 w-4",
        widthClass: "w-[150px] min-w-[150px] justify-center",
        Icon: X,
      };

  return (
    <div>
      <div className="pb-6">
        <div className="flex items-center justify-between text-sm font-normal pb-1 mt-3">
          <span className="small-title">{t("perksSection.groupInsurance.title")}</span>
          {/* <Button
            variant="link"
            label={currentLifestyleGroupName ? "Manage" : "Create"}
            onClick={() =>
              navigateToPage(1, currentLifestyleGroupName ? "/dashboard/lifestyle/main" : "/dashboard/lifestyle/create-group")
            }
          /> */}
        </div>
        <button
          type="button"
          onClick={() => navigateToPage(1, "/dashboard/group-insurance")}
          className="mt-1 flex w-full items-center justify-between gap-3 text-md text-neutral-mediumDark bg-white px-3 py-3 rounded-xl border text-left hover:border-primary-mediumish transition ease-in-out delay-0 duration-200 transform scale-100 hover:scale-101"
        >
          <div className="flex items-center gap-3">
            <div className="h-14 w-14 rounded-lg border border-neutral-light flex items-center justify-center bg-white shrink-0">
              <div
                className="flex items-center justify-center shrink-0"
                style={{ width: "48px", height: "48px", minWidth: "48px", minHeight: "48px" }}
              >
                <img
                  src={cardImageSrc}
                  alt={cardImageAlt}
                  className="rounded-full object-contain shrink-0"
                  style={{ width: "48px", height: "48px", minWidth: "48px", minHeight: "48px" }}
                />
              </div>
            </div>
            <span>
              <span className={`${titleClassName} text-neutral-darkest`}>
                {cardTitle}
              </span>
            </span>
          </div>
          <div className="flex flex-col items-end text-right leading-4 pr-2">
            <Badge
              variant="outline"
              className={`inline-flex items-center gap-2 rounded-full px-2.5 py-1 text-xs font-medium whitespace-nowrap ${statusConfig.badgeClass} ${statusConfig.widthClass}`}
            >
              <span
                className={`flex items-center justify-center rounded-full ${statusConfig.iconWrapperClass}`}
              >
                <statusConfig.Icon className={statusConfig.iconSizeClass} />
              </span>
              <span className="whitespace-nowrap">{statusConfig.label}</span>
            </Badge>
            {isProtected ? (
              <span className="text-xs text-neutral-mediumDark">
                {t("perksSection.groupInsurance.expiresOn", {
                  date: formattedResetDate ?? t("perksSection.groupInsurance.noExpiry"),
                })}
              </span>
            ) : null}
          </div>
        </button>
      </div>

            {/* <span className="ml-2">Protect your team. Let Parachute shop for the best insurance. <span className="text-primary-medium">Start now.</span></span> */}


      <div className="flex items-center justify-between text-sm font-normal">
        <span className="small-title">{t("perksSection.myBenefits")}</span>
      </div>
      <div className="flex flex-row flex-wrap pt-2 w-full">
          {perksData.filter(item => item.includedInPackage === true && (item.isAvailable === true || item.isBeta === true)).map((perk: any, index: number) => 
            <div className="pr-5 pb-3" key={index}>
              <Card
                variant="perkMini"
                onClick={() => {navigateToPage(3, `/dashboard/${perk.url}`)}}
                title={t(`perks.items.${perk.type}.title`)}
                icon={<Icon variant={perk.icon} size={24} />}
                isSelected={false}
                isAvailable={perk.isAvailable}
                includedInPackage={perk.includedInPackage}
                isBeta={perk.isBeta}
              />
            </div>
          )}
          
          {/* {addPlusIcon && (<div className="pr-5 pb-3">
            <Card
              variant="perkMini"
              onClick={() => {navigateToPage(3, "/dashboard/benefits")}}
              title="Add"
              icon={<PlusIcon size={24} />}
              isSelected={false}
              isAvailable={true}
              includedInPackage={true}
              isBeta={false}
            />
          </div>)} */}
        </div>
    </div>
  );
};
